import React, { Component } from "react";
import {
  Table,
  Pagination,
  Col,
  Row,
  Input,
  Select,
  Button,
  Tag,
  DatePicker
} from "antd";
import moment from "moment";
import { strings, newsTypes } from "../../helpers";
import ReactTags from "react-tag-autocomplete";
import AddDescModal from "./AddDescModal";
const { Search } = Input;
const { Option } = Select;
const { RangePicker } = DatePicker;

export default class NewsFeedListView extends Component {
  render() {
    const {
      promoCodeList,
      allRecords,
      pageNo,
      onPageChange,
      navigateToUsersDetails,
      toggleAddModal,
      deleteSelectedArticle,
      editNewsArticleForm,
      hasSelected,
      rowSelection,
      loading,
      newsArticleList,
      moveToArticleUrl,
      handleSearchText,
      handleSearch,
      searchText,
      requestArticlePublish,
      handleSearchByPublishStatus,
      searchByTag,
      suggestions,
      onSearchTagDelete,
      onSearchTagAddition,
      handleFilterNewsType,
      newsDesc,
      showAddDescModal,
      togglePublishDescModal,
      handleDescChange,
      handleFetchRssFeed,
      handleChangePageSizeChange,
      perPage,
      onDateFilterSelect,
      isProcessing,
      selectedRowKeys,
      handlePrepareWeeklyNews
    } = this.props;
    const columns = [
      {
        title: "News Heading",
        key: "news_heading",
        width: 150,
        align: "left",
        render: record => (
          <div className="news-article-heading">
            <a onClick={e => moveToArticleUrl(e, record)}>
              {" "}
              {record.news_type === "CME" ? record.event_name : record.title}
            </a>
          </div>
        )
      },
      {
        title: "Type",
        align: "left",
        render: record => <div>{record.news_type || "--"}</div>
      },
      {
        title: "Date",
        key: "date",
        align: "left",
        render: record => (
          <div>{moment(record.news_date).format("DD-MM-YYYY") || "--"}</div>
        )
      },
      {
        title: "Source",
        key: "expiry",
        align: "left",
        render: record => (
          <div>
            <div className="tbl-news-source-container">
              {record.source_thumbnail_url && (
                <div className="source-thumbnail-img">
                  <img src={record.source_thumbnail_url} />
                </div>
              )}

              <div className="source-name">{record.source_name}</div>
            </div>
          </div>
        )
      },
      {
        title: "Publish",
        key: "publish",
        align: "left",
        render: record => (
          <div>
            {record.published ? (
              <span className="text-green">Yes</span>
            ) : (
              <span className="text-red">No</span>
            )}{" "}
          </div>
        )
      },
      {
        title: "Tags",
        key: "tags",
        align: "left",
        render: record => (
          <div>
            {record.news_tags.map(item => (
              <Tag className="mb-5" color="green">
                {item.tag_name}
              </Tag>
            ))}
          </div>
        )
      },
      {
        title: "Shared Views",
        key: "viewed_count",
        align: "left",
        render: record => <div>{record.viewed_count}</div>
      },
      {
        title: "Shared Clicks",
        key: "shared_count",
        align: "left",
        render: record => <div>{record.shared_count}</div>
      },
      {
        align: "left",
        width: 100,
        render: record => (
          <div>
            {
              <Button
                type="default"
                shape="circle"
                icon="edit"
                className="mr-10"
                onClick={() => editNewsArticleForm(record, record.id)}
              />
            }
            {
              <Button
                type="default"
                shape="circle"
                icon="delete"
                onClick={() => deleteSelectedArticle(record.id)}
              />
            }
          </div>
        )
      },
    ];

    return (
      <div className="content-container">
        <div className="backgroundWhite">
          <Row>
            <Col className="heading-domain pl-0">News Feed</Col>
          </Row>
          <Row type="flex" align="top" gutter={8}>
            <Col span={6}>
              <label>Search</label>
              <Search
                className="mt-7"
                value={searchText}
                onChange={handleSearchText}
                placeholder={"Search news article"}
                onSearch={handleSearch}
                onPressEnter={handleSearch}
                allowClear
              />
            </Col>

            <Col>
              <label>Filter News Type</label>
              <div>
                <Select
                  defaultValue="ALL"
                  style={{ width: 120 }}
                  onChange={handleFilterNewsType}
                  className="mt-7"
                >
                  <Option value="ALL">All</Option>
                  {newsTypes.map(obj => {
                    return <Option value={obj}>{obj}</Option>;
                  })}
                </Select>
              </div>
            </Col>

            <Col>
              <label>Filter By status</label>
              <div>
                <Select
                  defaultValue="Both"
                  style={{ width: 120 }}
                  onChange={handleSearchByPublishStatus}
                  className="mt-7"
                >
                  <Option value="yes">Yes</Option>
                  <Option value="No">No</Option>
                  <Option value="both">Both</Option>
                </Select>
              </div>
            </Col>

            <Col span={5}>
              <label className="filter-by-tag">Filter by Tags</label>
              <ReactTags
                ref={this.reactTags}
                tags={searchByTag}
                suggestions={suggestions}
                onDelete={onSearchTagDelete}
                onAddition={onSearchTagAddition}
                placeholderText={"search tags"}
              />
            </Col>
            <Col span={5}>
              <label className="filter-by-tag">Filter by date range</label>
              <RangePicker
                format="DD/MM/YYYY"
                minDate={new Date()}
                onChange={onDateFilterSelect}
              />
            </Col>
          </Row>

          {/* <Col span={18}>
              <Row>
                <Col span={24}>
                  <Row type="flex" align="middle" gutter={20}>
                    <Col span={8}>
                      <label>Search</label>
                      <Search
                        className="mt-7"
                        value={searchText}
                        onChange={handleSearchText}
                        placeholder={"Search news article"}
                        onSearch={handleSearch}
                        onPressEnter={handleSearch}
                        allowClear
                      />
                    </Col>
                    <Col span={16}>
                      <Row type="flex" gutter={8}>
                        <Col span={8}>
                          <Row>
                            <Col>
                              <label>Filter News Type</label>
                            </Col>
                            <Col>
                              <Select
                                defaultValue="All"
                                style={{ width: 120 }}
                                onChange={handleSearchByPublishStatus}
                                className="mt-7"
                              >
                                {newsTypes.map(obj => {
                                  return <Option value={obj}>{obj}</Option>;
                                })}
                              </Select>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={8}>
                          <Row>
                            <Col>
                              <label>Filter By status</label>
                            </Col>
                            <Col>
                              <Select
                                defaultValue="Both"
                                style={{ width: 120 }}
                                onChange={handleSearchByPublishStatus}
                                className="mt-7"
                              >
                                <Option value="yes">Yes</Option>
                                <Option value="No">No</Option>
                                <Option value="both">Both</Option>
                              </Select>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={12}>
                          <label className="filter-by-tag">
                            Filter by Tags
                          </label>
                          <ReactTags
                            ref={this.reactTags}
                            tags={searchByTag}
                            suggestions={suggestions}
                            onDelete={onSearchTagDelete}
                            onAddition={onSearchTagAddition}
                            placeholderText={"search tags"}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col> */}
          <Row type="flex" align="top" gutter={8} className="mt-10">
          <Col>
              <Button
                type="primary"
                // loading={loading}
                disabled={!hasSelected ||selectedRowKeys.length < 1}
                onClick={handlePrepareWeeklyNews}
              >
                Prepare Weekly news
              </Button>
            </Col>
            <Col>
              <Button
                type="primary"
                loading={loading}
                onClick={handleFetchRssFeed}
              >
                Fetch RSS feed
              </Button>
            </Col>

            <Col>
              <Button
                type="primary"
                disabled={!hasSelected}
                loading={loading}
                // shape="circle"
                // icon="plus"
                onClick={() => togglePublishDescModal()}
              >
                Publish News
              </Button>
            </Col>
            <Col>
              <Button
                type="primary"
                // shape="circle"
                // icon="plus"
                onClick={() => toggleAddModal()}
              >
                Add News
              </Button>
            </Col>
            <Col>
              <Button
                type="default"
                disabled={!hasSelected}
                loading={isProcessing}
                onClick={() => deleteSelectedArticle(selectedRowKeys)}
              >
                Delete 
              </Button>
            </Col>
          </Row>

          <div className="mt-20 kc-block white-bg round-borders-4x">
            <Table
              rowSelection={rowSelection}
              columns={columns}
              dataSource={newsArticleList}
              pagination={false}
              rowKey="id"
            />
          </div>
        </div>
        <div className="pagination-wrapper">
          {allRecords > 10 && (
            <div className="total-results-wrap">
              <span className="result-count">{allRecords}</span>
              {allRecords > 1 ? strings.results : strings.result}
            </div>
          )}
          {allRecords > 10 && (
            <Pagination
              total={allRecords}
              current={pageNo}
              onChange={onPageChange}
              pageSize={perPage}
              defaultCurrent={pageNo}
              showSizeChanger
              showQuickJumper
              onShowSizeChange={handleChangePageSizeChange}
              pageSizeOptions={[
                "10",
                "50",
                "100",
                "150",
                "200",
                "250",
                "300",
                "350",
                "400",
                "450",
                "500"
              ]}
            />
          )}
        </div>
        {showAddDescModal && (
          <AddDescModal
            showModal={showAddDescModal}
            toggleModal={togglePublishDescModal}
            handleDescChange={handleDescChange}
            newsDesc={newsDesc}
            requestArticlePublish={requestArticlePublish}
          />
        )}
      </div>
    );
  }
}
